import { useContext } from "react";
import style from "./HanburgerMenu.module.css";
import HamburgerMenuContext from "../../../context/hamburgerMenuContext";

function HamburgerMenu() {
  const { hambergerMenu, setHambergerMenu } = useContext(HamburgerMenuContext);

  return (
    <button
      className={
        "me-4 d-xl-none " +
        style.hamburger +
        (hambergerMenu ? " " + style.isActive : "")
      }
      onClick={() => {
        setHambergerMenu(cur => !cur);
      }}
    >
      <div className={style.bar}></div>
    </button>
  );
}

export default HamburgerMenu;
